import React from 'react';
import { Link } from 'react-router-dom';
import Modal from './Modal';
import FormsySimpleInput from '../form/FormsySimpleInput';
import Formsy from 'formsy-react';
import Pagination from '../shared/Pagination';
import { menuAPI } from '../../InterfaceAPI/menuAPI';
import { debounce } from '../../helpers/util';

class AddIngredientModal extends React.Component {
  defaultState = {
    lastTerm: '',
    searchTerm: '',
    products: [],
    pagination: {}
  };

  state = {
    ...this.defaultState
  };

  render() {
    const { handleSearch, submitSearch } = this;
    const { isOpen, closeModal } = this.props;
    const { searchTerm, pagination } = this.state;
    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        className="modal modal--no-padding admin-wrapper"
      >
        <div className="modal__head modal__head--flush-bottom">
          <h2 className="h2 modal__heading">Add an Ingredient</h2>
          <Formsy className="form" onValidSubmit={submitSearch}>
            <div className="cms__bar cms__bar--margin-bot">
              <div className="cms__bar-item cms__bar-item--full">
                <FormsySimpleInput
                  type="text"
                  name="searchTerm"
                  placeholder="Enter Product Name"
                  className="simple-input simple-input--pad-right"
                  value={searchTerm}
                  onChange={handleSearch}
                  autoComplete="off"
                />
              </div>
              <div className="cms__bar-item">
                <input
                  type="submit"
                  value="Search"
                  className="btn btn--solid-blue"
                />
              </div>
            </div>
          </Formsy>
        </div>
        <div className="modal__body modal__body--tall">
          <div className="add-dish">{this.renderProducts()}</div>
          <div className="cms__pagination">
            <Pagination
              pageCount={pagination.total_pages || 1}
              forcePage={pagination.current_page - 1 || 0}
              onPageChange={this.handlePaginate}
            />
          </div>
          <Link
            to="/admin/product"
            className="a--blue add-dish__create-link"
            target="_blank"
          >
            Create a New Product
          </Link>
        </div>
      </Modal>
    );
  }

  renderProducts() {
    const { products, lastTerm, pagination } = this.state;
    if (products.length === 0)
      return (
        <div className="add-dish__results add-dish__results--empty">
          Enter a product name to see results to add to the menu.
        </div>
      );
    else
      return (
        <div className="add-dish__results">
          <div className="add-dish__results-count">
            <span className="p p--bold">{pagination.total_items} Results </span>
            {lastTerm !== '' ? `for "${lastTerm}"` : ''}
          </div>
          <div className="add-dish__list">
            {products.length > 0
              ? products.map(product => this.renderProduct(product))
              : ''}
          </div>
        </div>
      );
  }

  renderProduct(product) {
    return (
      <div
        key={product.id}
        className="add-dish__item"
        onClick={() => this.addIngredient(product)}
      >
        {product.name}
      </div>
    );
  }

  addIngredient = product => {
    this.props.addIngredient(product);
    this.setState({ ...this.defaultState });
  };

  submitSearch = (page = 1) => {
    const { searchTerm: name } = this.state;
    this.setState({ products: [], isLoading: true });
    // make request
    menuAPI
      .searchProducts({ page, search: { name } })
      .then(({ products, pagination }) =>
        this.setState({
          products,
          pagination,
          isLoading: false,
          lastTerm: name
        })
      )
      .catch(error => console.log(error));
  };

  debouncedHideError = debounce(() => this.submitSearch(), 200);

  handleSearch = e => {
    this.setState({ searchTerm: e.target.value }, this.debouncedHideError);
  };

  handlePaginate = ({ selected: page }) => this.submitSearch(page + 1);
}

export default AddIngredientModal;



// WEBPACK FOOTER //
// ./src/components/shared/AddIngredientModal.js